<script lang="ts">
  import { SelectButton } from "primevue";
  import { useField } from "vee-validate";
  import { PropType, useAttrs } from "vue";
  import { Message } from "@/ui";

  // @ts-ignore
  Object.values(SelectButton.components).forEach((component) => {
    // @ts-ignore
    component.compatConfig = {
      MODE: 3,
      COMPONENT_V_MODEL: false,
    };
  });

  // @ts-ignore
  SelectButton.compatConfig = {
    MODE: 3,
    COMPONENT_V_MODEL: false,
  };

  export default {
    components: { SelectButton, Message },
    props: {
      name: {
        type: String,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
      ariaLabelledby: {
        type: String,
        default: "",
      },
      required: {
        type: Boolean,
        default: false,
      },
      classes: {
        type: Object as PropType<{ selectButton?: string; wrapper?: string }>,
        default: {},
      },
      // define class here to not bind it to the component
      class: {
        type: String,
        default: "",
      },
    },
    setup(props) {
      const attrs = useAttrs();
      const { value: localValue, errorMessage, meta, handleBlur: fieldBlur, setValue } = useField(() => props.name);

      return {
        localValue,
        errorMessage,
        meta,
        fieldBlur,
        setValue,
        classes: props.classes,
        attrs,
      };
    },
    compatConfig: {
      MODE: 3,
    },
  };
</script>

<template>
  <div :class="classes.wrapper">
    <div class="grid grid-cols-[auto,1fr] gap-[16px] items-center">
      <SelectButton
        class="select-button"
        :class="[{ 'has-aria-label': ariaLabelledby }, classes.selectButton]"
        v-bind="{ ...$props, ...$attrs }"
        v-model="localValue"
        :name="name"
        :invalid="!!errorMessage"
        aria-labelledby="custom"
        optionDisabled="disabled"
      >
        <template v-if="ariaLabelledby" #option="slotProps">
          <img v-if="slotProps.option.image" :src="slotProps.option.icon" alt="icon" class="w-[24px] h-[24px]" />
          <span v-else-if="slotProps.option.label">{{ slotProps.option.label }}</span>
          <i v-else :class="slotProps.option.icon"></i>
        </template>
      </SelectButton>
      <label v-if="label" class="text-[14px] font-normal line-clamp-2">
        {{ label }}
        <span v-if="required" class="text-[#FF55C6]">*</span>
      </label>
    </div>
    <Message v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>

<style scoped>
  ::v-deep(.p-togglebutton) {
    @apply bg-white text-[#4641D5] !border-gray-new-500 text-[16px] w-[122px] h-[40px] font-normal;
  }

  ::v-deep(.has-aria-label .p-togglebutton) {
    @apply h-[40px] w-[40px] p-0;
  }

  ::v-deep(.p-togglebutton.p-togglebutton-checked) {
    @apply bg-[#4641D5];
  }

  ::v-deep(.p-togglebutton-checked .p-togglebutton-content) {
    @apply bg-[#4641D5] text-white;
  }

  ::v-deep(.p-togglebutton-content) {
    @apply p-[0];
  }
</style>
